import AddWorkspaceMemberSideBar from "./AddWorkspaceMemberSideBar";

export default AddWorkspaceMemberSideBar;
